/**
 * Navigation contract of the portal. Legacy (TecWeb) knows only the Shell entry points below
 * and never decides where a user goes: every decision is taken by the Shell on the landing route.
 */
export const ShellRoutes = {
  /** Entry page of the portal. Accepts `?returnUrl=` (deeplink requested before sign-in). */
  welcome: '/public/welcome',
  /** Post sign-in decision point: deeplink first, otherwise the User Journey. Also the Legacy fallback. */
  landing: '/landing',
  callback: '/callback',
  error: '/error',
  noOrganizationsConnected: '/no-organizations-connected',
  orderProBasket: '/orders/basket'
} as const;

/** Legacy portal pages, relative to `/newapp`. */
export const LegacyRoutes = {
  /** Legacy drops its own authentication data here and returns the user to the Shell welcome page. */
  signedOut: '/auth/welcome',
  dashboard: '/home/dashboard',
  /**
   * The classic basket. Opened directly (bookmark, typed or shared link) it is a deeplink, see `ClassicBasketDeeplink`;
   * the portal opens it with an entry token (`withClassicBasketEntry`).
   */
  basket: '/requestorder/basket',
  mobileBasket: '/requestorder/mbasket'
} as const;

/** Query parameter carrying a deeplink to the Shell welcome page. */
export const RETURN_URL_PARAM = 'returnUrl';

/** Query parameter telling the Order Pro basket to show why the user was redirected from the classic basket. */
export const REROUTED_FROM_LEGACY_PARAM = 'reroutedFromLegacy';
